// import ViewStack from '../core/view-manager/view-stack'
// import ViewFactory from '../core/view-manager/view-factory'
// import NavigationController from '../core/view-manager/navigation-controller'
// import NavigationAPI from '../core/view-manager/navigation-api'
// import ContentLoader from '../core/view-manager/content-loader'
// import HistoryController from '../core/view-manager/history-controller'
import StackController from '../core/view-manager/stack-controller'
import NavigationAdapter from '../core/view-manager/navigation-adapter'
import ContentLoader from '../core/view-manager/content-loader'
import personView from '../core/view-manager/views/person-view'
import projectView from '../core/view-manager/views/project-view'
import simpleView from '../core/view-manager/views/simple-view'
import formView from '../core/view-manager/views/form-view'
import overlayView from '../core/view-manager/views/overlay-view'

import formContactView from '../core/view-manager/views/form-contact-view'
import formUploadView from '../core/view-manager/views/form-upload-view'

const VIEW_REGISTRY = [['overlay-view', overlayView]]

const HASH_TO_VIEW = {}

const bindHashRouting = (viewManager, swup) => {
	const handleHash = () => {
		const type = HASH_TO_VIEW[window.location.hash]

		if (!type) {
			if (viewManager.stack?.length) viewManager.closeTop({ fromPop: true })
			return
		}

		const top = viewManager.stack?.[viewManager.stack.length - 1]
		if (top?.view?.type === type) return

		viewManager.open({ type, url: null, static: true, suppressHistory: true })
	}

	// Make sure Swup doesn't hijack hash links
	document.addEventListener(
		'click',
		(e) => {
			const link = e.target.closest('a[href^="#"]')
			if (!link) return
			const href = link.getAttribute('href')
			if (!HASH_TO_VIEW[href]) return
			e.preventDefault()
			e.stopPropagation()
			if (window.location.hash !== href) {
				window.location.hash = href
			} else {
				handleHash()
			}
		},
		true,
	)

	window.addEventListener('hashchange', handleHash)

	// Swup anchor clicks might not trigger hashchange
	if (swup?.hooks?.on) {
		swup.hooks.on('link:anchor', handleHash)
	}

	handleHash()
}

export const initViewManager = (ctx) => {
	const adapter = new NavigationAdapter({ swup: ctx.swup })
	const contentLoader = new ContentLoader({ swup: ctx.swup })

	const viewManager = new StackController({
		rootSelector: '.js-views-manager',
		adapter,
		contentLoader,
		lenis: false,
		services: {
			componentsManager: ctx.componentsManager,
		},
	})

	VIEW_REGISTRY.forEach(([type, view]) => viewManager.register(type, view))

	document.addEventListener('view:close', () => viewManager.closeTop())

	viewManager.mount()
	bindHashRouting(viewManager, ctx.swup)

	ctx.viewManager = viewManager
	return viewManager
	// const adapter = new NavigationAdapter({ swup: ctx.swup })
	// const contentLoader = new ContentLoader({ swup: ctx.swup })

	// const viewManager = new StackController({
	// 	rootSelector: '.js-views-manager',
	// 	adapter,
	// 	contentLoader,
	// 	lenis: false,
	// 	services: {
	// 		componentsManager: ctx.componentsManager,
	// 	},
	// })

	// // viewManager.register('person', personView)
	// // viewManager.register('project', projectView)
	// viewManager.register('simple', simpleView)
	// viewManager.register('form-contact', formContactView)
	// viewManager.register('form-upload', formUploadView)

	// const hashToView = {
	// 	'#upload-cv': 'form-upload',
	// 	'#contact': 'form-contact',
	// }

	// const handleHash = () => {
	// 	const type = hashToView[window.location.hash]
	// 	if (!type) return
	// 	const top = viewManager.stack?.[viewManager.stack.length - 1]
	// 	if (top?.view?.type === type) return
	// 	viewManager.open({ type, url: null, static: true })
	// }

	// window.addEventListener('hashchange', handleHash)
	// handleHash()

	// // close handling
	// document.addEventListener('view:close', () => {
	// 	viewManager.closeTop()
	// })

	// console.log('Mounting View Manager')
	// viewManager.mount()

	// ctx.viewManager = viewManager
	// console.log('Initializing View Manager')

	// return viewManager
}
